"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefCompIdsFromInflatedId = exports.getTemplateFromInflatedId = exports.getMultipleRefCompsIdFromInflatedId = exports.getRefCompIdFromInflatedId = exports.getUniqueId = exports.REF_DELIMITER = void 0;
exports.REF_DELIMITER = '_r_';
const getUniqueId = (refId, originalId) => `${refId}${exports.REF_DELIMITER}${originalId}`;
exports.getUniqueId = getUniqueId;
const getRefCompIdFromInflatedId = (id) => id.split(`${exports.REF_DELIMITER}`)[0];
exports.getRefCompIdFromInflatedId = getRefCompIdFromInflatedId;
// Will give different result than getRefCompIdFromInflatedId()
// in case of widget-in-widget. for example:
// id='firstRefComp_r_secondRefComp_r_innerCompId' -> return 'firstRefComp_r_secondRefComp'
const getMultipleRefCompsIdFromInflatedId = (id) => {
    return id.substring(0, id.lastIndexOf(`${exports.REF_DELIMITER}`)) || id;
};
exports.getMultipleRefCompsIdFromInflatedId = getMultipleRefCompsIdFromInflatedId;
const getTemplateFromInflatedId = (id) => id.split(exports.REF_DELIMITER).pop();
exports.getTemplateFromInflatedId = getTemplateFromInflatedId;
const getRefCompIdsFromInflatedId = (id) => (0, exports.getMultipleRefCompsIdFromInflatedId)(id).split(`${exports.REF_DELIMITER}`);
exports.getRefCompIdsFromInflatedId = getRefCompIdsFromInflatedId;
//# sourceMappingURL=refUtils.js.map